import i18next from "i18next";
import en_US from "./en_US.json";
import da_DK from "./da_DK.json";
import de_DE from "./de_DE.json";
import de_CH from "./de_CH.json";
import hu_HU from "./hu_HU.json";
import fr_FR from "./fr_FR.json";
import it_IT from "./it_IT.json";
import nl_NL from "./nl_NL.json";
import type { Resource } from "i18next";

const defaultLanguage = "en_US";

function enabledLanguages() {
  // all our available language resources, if VITE_LANGUAGES is not specified
  const resources: Resource = {
    en_US,
    da_DK,
    de_DE,
    de_CH,
    fr_FR,
    it_IT,
    hu_HU,
    nl_NL,
  };

  // check if we have to limit languages
  if (import.meta.env.VITE_LANGUAGES) {
    const items = import.meta.env.VITE_LANGUAGES.split(",").map((item) =>
      item.trim()
    );
    const filtered: Resource = {};
    items.forEach((id) => {
      if (resources[id]) {
        filtered[id] = resources[id];
      }
    });
    // make sure the fallback language is always included!
    if (filtered[defaultLanguage] === undefined) {
      filtered[defaultLanguage] = resources[defaultLanguage];
    }

    return filtered;
  } else {
    return resources;
  }
}

i18next.init({
  lng: defaultLanguage,
  // Crowdin doesn't support v4 but the TS library only supports v4!
  compatibilityJSON: "v4",
  interpolation: {
    // escapeValue: false
    // skipOnVariables: false
  },
  fallbackLng: defaultLanguage,
  resources: enabledLanguages(),
});

export default i18next;
